module.exports = __webpack_public_path__ + "img/logo.46a1ff68.svg";